const ParkStatisticsActionTypes = {
  SET_GENERAL_STATS: "parkStatistics/SET_GENERAL_STATS",
  SET_CONTROLS_STATS: "parkStatistics/SET_CONTROLS_STATS",
  SET_DAILY_ATTENDANCE_STATS: "parkStatistics/SET_DAILY_ATTENDANCE_STATS",
  SET_DETAILS_STATS: "parkStatistics/SET_DETAILS_STATS",
  SET_LOADING: "parkStatistics/SET_LOADING",
  SET_AUTO_REFRESH: "parkStatistics/SET_AUTO_REFRESH",
  SET_INITIALIZED: "parkStatistics/SET_INITIALIZED",
  SET_MAP_INFOS: "parkStatistics/SET_MAP_INFOS",
  SET_SELECTED_LAYERS: "parkStatistics/SET_SELECTED_LAYERS",
  SET_FILTER: "parkStatistics/SET_FILTER",
  SET_FILTERS: "parkStatistics/SET_FILTERS",
  ERROR_ON_RETRIEVE: "parkStatistics/ERROR_ON_RETRIEVE",
  REMOVE_ERROR: "parkStatistics/REMOVE_ERROR",
  SET_ATTENDANCE_TIME_LIMIT: "parkStatistics/SET_ATTENDANCE_TIME_LIMIT",
};

export default ParkStatisticsActionTypes;
